// extracted by mini-css-extract-plugin
export var bounce = "_ma-1";
export var generatingText = "_ma-6";
export var lightning = "_ma-4";
export var popup = "_ma-5";
export var progressBar = "_ma-7";
export var progressFill = "_ma-8";
export var progressShimmer = "_ma-9";
export var progressText = "_ma-a";
export var shimmer = "_ma-3";
export var uploadIcon = "_ma-0";
export var uploadingText = "_ma-2";